/**
 * Welcome Animation Constants
 *
 * Timing values, configuration, and types for the theatrical
 * fly-system welcome animation.
 */

// Animation phase type
export type AnimationPhase =
  | "idle" // Not showing (repeat visits start here)
  | "dwell" // Waiting before animation starts
  | "fly_in" // Backdrop descending, sandbag rising
  | "settle" // Bounce/settle at rest position
  | "rest" // Showing, awaiting user dismissal
  | "fly_out"; // Reverse animation (dismissal)

// Animation timing in milliseconds
export const ANIMATION_TIMING = {
  DWELL_DURATION: 1000, // Initial wait before animation
  FLY_DURATION: 6000, // Animation duration (6 seconds to match sandbag)
  SETTLE_DURATION: 600, // Bounce settle at end
  FLY_OUT_DURATION: 6000, // Reverse animation duration (6 seconds)
} as const;

// localStorage key for persistence
export const STORAGE_KEY = "stagecraft_welcome_seen";

// Z-index values (below CookieConsent at 1000)
export const Z_INDEX = {
  OVERLAY: 900,
  BACKDROP: 901,
  COUNTERWEIGHT: 902,
  PERSISTENT_SANDBAG: 100,
} as const;

// Asset paths
export const ASSETS = {
  BACKDROP: "/images/welcome/Ropes.png",
  SANDBAG: "/images/welcome/Bag-on-Rope.png",
  SOUND: "/sounds/fly-system.mp3",
} as const;

// Breakpoint for mobile (hide sandbag below this)
export const MOBILE_BREAKPOINT = 768;
